import bem from "easy-bem";
import ScriptsRunner from "features/admin-scripts/blocks/ScriptsRunner";
import EditorialFeed from "features/editorial/blocks/EditorialFeed";
import CasesExport from "features/moderatorial/blocks/CasesExport";
import ModeratorialFeed from "features/moderatorial/blocks/ModeratorialFeed";
import { PersonalProfileEdit } from "features/people/blocks/PersonalProfile";
import React from "react";
import TabBar from "ui/TabBar";

import { useProfileTabs } from "./hooks/useProfileTabs";

import "./ProfileTabs.css";

const cn = bem("profile-tabs");

// Верхний переключатель на странице профиля: ролевые вкладки (модераторская/
// редакторская) плюс личная. Переключатель прижат вправо.
const ProfileTabs: React.FC = () => {
  const { options, activeTab, setTab } = useProfileTabs();

  return (
    <div className={cn()}>
      {/* Одиночная вкладка «Личное» — переключатель не нужен. */}
      {options.length > 1 && (
        <div className={cn("tabs")}>
          <TabBar
            value={activeTab}
            options={options}
            onChange={setTab}
          />
        </div>
      )}

      {activeTab === "moderatorial" && <ModeratorialFeed />}
      {activeTab === "editorial" && <EditorialFeed />}
      {activeTab === "export" && <CasesExport />}
      {activeTab === "scripts" && <ScriptsRunner />}
      {activeTab === "profile" && <PersonalProfileEdit />}
    </div>
  );
};

export default ProfileTabs;
